/**
 * OpenAI Integration — transport and request contract (data).
 *
 * The provider layer is abstract: OpenAI, Claude, Gemini and any future
 * provider implement exactly the same contract and reach the model through the
 * same secure backend proxy. No API key exists in the frontend.
 */

export const PROMPT_SCHEMA_ID = 'designprompt/1';
export const PROMPT_VERSION = 1;

/** Every provider the proxy can attach a server-side key for. */
export const PROVIDERS = Object.freeze(['openai', 'claude', 'gemini']);

/**
 * There is deliberately no model list here.
 *
 * The browser chooses the PROVIDER; the server chooses the model, from its own
 * configuration. A model name in the bundle was a browser-supplied instruction
 * about what the operator pays for, and the proxy accepted it whenever it
 * happened to be allowed.
 */

/** The admin-authenticated proxy that holds the keys. */
export const GENERATE_ENDPOINT = '/api/admin/ai-generator/generate';
export const ADMIN_TOKEN_KEY = 'admin_token';

/** Structured output only — the model returns one JSON object, never prose. */
export const RESPONSE_FORMAT = Object.freeze({ type: 'json_object' });

/** Transport defaults: a design document is large and worth waiting for, once. */
export const DEFAULT_TRANSPORT = Object.freeze({
  timeoutMs: 120000,
  retries: 2,
  backoffMs: 1000,
  maxTokens: 12000,
});

/** Statuses worth retrying: rate limits and transient upstream failures. */
export const RETRYABLE_STATUSES = Object.freeze([408, 409, 425, 429, 500, 502, 503, 504]);

/** How many concepts one request may ask for. */
export const MAX_COUNT = 10;
